import { SimpleGrid, SimpleGridProps } from '@chakra-ui/react'

export default SimpleGrid

export type { SimpleGridProps }
